import { AccountTabScreenBoundary } from '@/src/components/navigation/AccountTabScreenBoundary'
import { useAppSession } from '@/src/contexts/AppSessionContext'
import LibraryScreen from '@/src/features/library/screens/LibraryScreen'
import { SubscriptionRequiredPlaceholder } from '@/src/features/paywall/components/SubscriptionRequiredPlaceholder'

export default function LibraryTab() {
  const { hasPurchased } = useAppSession()

  if (!hasPurchased) {
    return <SubscriptionRequiredPlaceholder />
  }

  return (
    <AccountTabScreenBoundary>
      <LibraryScreen />
    </AccountTabScreenBoundary>
  )
}
